export default '/build/ff30477b.svg'